/**
 * Alias de los productos de las paginas para orion
 */
export const ALIAS = {
  HOME: 'fondoseuropeos',
  EXPERTO: 'experto-digital',
  BENEFICIOS: 'digitalizacion-empresas',
  DIGITAL: 'kit-digital',
  CONSULTING: 'kitconsulting-r',
  AYUDA: 'fondoseuropeos',
  CONTRATOS: 'contratos',
  BONO: 'bono-pyme',
}

export const ALIAS_PRODUCT = {
  HOME: 'Fondos Europeos FONDOSEUROPEOS',
  CONSULTING: 'Fondos Europeos Kit Consulting',
  EXPERTO: 'Fondos Europeos Experto Digital',
  BENEFICIOS: 'Fondos Europeos Digitalizacion Empresas',
  DIGITAL: 'Fondos Europeos Kit Digital',
  AYUDA: 'Fondos Europeos Entender Ayudas',
  CONTRATOS: 'Fondos Europeos Contratos',
  BONO: 'Fondos Europeos Bono Pyme',
};
